import { observable } from "mobx";
import { Type } from "class-transformer";
import DateRangeRequest from "./dateRangeRequest";
import DecimalRangeRequest from "./decimalRangeRequest";
import OutgoingPayGatePaymentStatus from "./outgoingPayGatePaymentStatus";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingPayGatePaymentsRequest {
  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  countryId?: string;

  @observable
  licensePlate?: string;

  @observable
  variableSymbol?: number;

  @observable
  @Type(() => DateRangeRequest)
  authorizedDate?: DateRangeRequest;

  @observable
  @Type(() => DateRangeRequest)
  exportedDate?: DateRangeRequest;

  @observable
  @Type(() => DecimalRangeRequest)
  paidAmount?: DecimalRangeRequest;

  @observable
  cardNumber?: string;

  @observable
  arn?: string;

  @observable
  officialRecordId?: string;

  @observable
  status?: OutgoingPayGatePaymentStatus;

  @observable
  chargeId?: string;

  @observable
  chargeOrderId?: string;
}

export const OutgoingPayGatePaymentsRequestValidationRules: EntityValidationRules<OutgoingPayGatePaymentsRequest> = {
  variableSymbol: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  cardNumber: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  arn: {
    isLength: {
      min: 3,
      optional: true,
    },
  },
  officialRecordId: {
    isLength: {
      min: 3,
      max: 50,
      optional: true,
    },
  },
  licensePlate: {
    isLicensePlate: {
      required: false,
    },
    isLength: {
      min: 1,
      optional: true,
    },
  },
  paidAmount: {
    isNumberRange: {
      min: 0,
    },
  },
  chargeId: {
    isLength: {
      min: 32,
      max: 36,
      optional: true,
    },
  },
  chargeOrderId: {
    isLength: {
      min: 36,
      max: 36,
      optional: true,
    },
  },
};
